import { useState, useEffect, useRef } from "react";

import mobileImageTRIENNALE from '@/assets/images/mobile/laureata-con-corona-di-alloro.webp'
import mobileImageLINGUE from '@/assets/images/mobile/gruppo-di-studio-esame-di-grammatica.webp'
import mobileImageMAGISTRALE from '@/assets/images/mobile/studenti-in-aula-durante-lezione.webp'
import mobileImageMASTER from '@/assets/images/mobile/laureati-celebrano-laurea.webp'
import mobileImagePHD from '@/assets/images/mobile/studentessa-in-citta-con-libri-e-cuffie.webp'
import mobileImageSPECIALIZZAZIONE from '@/assets/images/mobile/uniforme-medica-con-stetoscopio.webp'
import Image from "next/image";

const InfiniteCarousel = () => {
    const carouselData = [
        { id: 1, text: "Master universitario di primo o secondo livello", img: mobileImageTRIENNALE, alt: "Giovane laureata con corona di alloro in testa, simbolo della laurea in Italia, sorridente e immersa nella natura." },
        { id: 2, text: "Corso di Laurea Triennale o Specialistica a ciclo unico", img: mobileImageMAGISTRALE, alt: "Studenti concentrati che prendono appunti durante una lezione in aula universitaria." },
        { id: 3, text: "Corso di Laurea Magistrale", img: mobileImageLINGUE, alt: "Studenti riuniti attorno a un tavolo per una sessione di studio, analizzando un test di grammatica." },
        { id: 4, text: "Corso di lingue di almeno sei mesi, riconosciuto da un ente certificatore", img: mobileImagePHD, alt: "Giovane studentessa sorridente con cuffie e libri in mano, cammina per la città con uno sfondo urbano suggestivo." },
        { id: 5, text: "Dottorato di Ricerca triennale all’estero", img: mobileImageSPECIALIZZAZIONE, alt: "Primo piano di un camice medico azzurro con stetoscopio riposto nella tasca." },
        { id: 6, text: "Corso di specializzazione post-laurea in Medicina e Chirurgia a ciclo unico", img: mobileImageMASTER, alt: " Gruppo di studenti in abiti da laurea che festeggiano all’aperto, lanciando i cappelli in aria e tenendo in mano i diplomi." },
    ];

    const carouselRef = useRef<HTMLDivElement | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalSlides = carouselData.length;

    const [touchStart, setTouchStart] = useState<number | null>(null);
    const [touchEnd, setTouchEnd] = useState<number | null>(null);

    const goToSlide = (index: number) => {
        if (carouselRef.current) {
            const cardWidth = (carouselRef.current.firstChild as HTMLElement).clientWidth;
            carouselRef.current.scrollLeft = cardWidth * index;
            setCurrentIndex(index);
        }
    };

    const handleInfiniteScroll = () => {
        const cardWidth = (carouselRef.current?.firstChild as HTMLElement)?.clientWidth || 0;
        const maxScrollLeft = (carouselRef.current?.scrollWidth || 0) - (carouselRef.current?.clientWidth || 0);

        if (carouselRef.current) {
            if (carouselRef.current.scrollLeft <= 0) {
                carouselRef.current.classList.add("no-transition");
                carouselRef.current.scrollLeft = maxScrollLeft - cardWidth;
                carouselRef.current.classList.remove("no-transition");
            } else if (Math.ceil(carouselRef.current.scrollLeft) >= maxScrollLeft) {
                carouselRef.current.classList.add("no-transition");
                carouselRef.current.scrollLeft = cardWidth;
                carouselRef.current.classList.remove("no-transition");
            }
        }
    };

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.scrollLeft = (carouselRef.current.firstChild as HTMLElement)?.clientWidth || 0;
        }
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            goToSlide((currentIndex + 1) % totalSlides);
        }, 5000); // Auto-scroll after 10 seconds

        return () => clearTimeout(timeoutId);
    }, [currentIndex, totalSlides]);

    // Handle touch events for mobile swiping
    const handleTouchStart = (e: React.TouchEvent) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const threshold = 50; // Min distance for swipe to be valid

        if (distance > threshold) {
            // Swipe left
            goToSlide((currentIndex + 1) % totalSlides);
        } else if (distance < -threshold) {
            // Swipe right
            goToSlide((currentIndex - 1 + totalSlides) % totalSlides);
        }

        // Reset touch positions
        setTouchStart(null);
        setTouchEnd(null);
    };

    return (
        <div className="relative w-full max-w-4xl overflow-hidden mx-auto">
            <div
                ref={carouselRef}
                className="flex overflow-hidden scroll-snap-x scroll-smooth space-x-4 px-8"
                onScroll={handleInfiniteScroll}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {carouselData.slice(-2).map((card) => (
                    <div
                        key={`clone-start-${card.id}`}
                        className="relative h-96 w-72 bg-cover bg-center rounded-3xl shadow-md flex flex-col justify-end px-12 py-5 text-white"
                    >
                        <Image src={card.img} alt="hero" className="lg:hidden rounded-cornerMob " style={{ objectFit: "cover" }} fill />

                        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-3xl z-0"></div>
                        <div className="relative">
                            <h2 className="text-xl font-semibold">{card.text}</h2>
                        </div>
                    </div>
                ))}
                {carouselData.map((card) => (
                    <div
                        key={card.id}
                        className="relative h-96 w-72 bg-cover bg-center rounded-3xl shadow-md flex flex-col justify-end px-12 py-5 text-white"
                    >
                        <Image src={card.img} alt="hero" className="lg:hidden rounded-cornerMob  " style={{ objectFit: "cover" }} fill />
                        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-3xl z-0"></div>
                        <div className="relative">
                            <h2 className="text-xl font-semibold">{card.text}</h2>
                        </div>
                    </div>
                ))}
                {carouselData.slice(0, 2).map((card) => (
                    <div
                        key={`clone-end-${card.id}`}
                        className="relative h-96 w-72 bg-cover bg-center rounded-3xl shadow-md flex flex-col justify-end px-12 py-5 text-white"
                    >
                        <Image src={card.img} alt="hero" className="lg:hidden rounded-cornerMob " style={{ objectFit: "cover" }} fill />
                        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-3xl z-0"></div>
                        <div className="relative">
                            <h2 className="text-xl font-semibold">{card.text}</h2>
                        </div>
                    </div>
                ))}
            </div>

            <div className="flex justify-center mt-4 space-x-2">
                {carouselData.map((_, index) => (
                    <button
                        key={index}
                        aria-label={carouselData[index].text}
                        onClick={() => goToSlide(index)}
                        className={`w-4 h-4 rounded-full ${index === currentIndex ? 'bg-blueLight' : 'bg-grayLight'}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default InfiniteCarousel;
